import {lazy} from '@aboutyou/lazy-imports';

export const TrackSearch = lazy(() =>
  import('./TrackSearch.eager').then(mod => ({default: mod.TrackSearch})),
);
